import { apiClient, safeApi } from '../../utils/axiosWithAuth';
import { ApiResponse } from '../../utils/axiosWithAuth';
import { TransferDTO, CreateTransferDTO, TransferPaginationResponse } from '../../types/transfer';

export const createTransferAPI = (dto: CreateTransferDTO) =>
  safeApi<TransferDTO>(() =>
    apiClient.post<ApiResponse<TransferDTO>>('/transfers', dto)
  );

export const deleteTransferAPI = (uuid: string) =>
  safeApi<{ deleted: boolean }>(() =>
    apiClient.delete<ApiResponse<{ deleted: boolean }>>(`/transfers/${uuid}`)
  );

export const fetchTransfersAPI = (page = 1, limit = 10, search?: string, storeId?: string, type?: string, fromDate?: string, toDate?: string) =>
  safeApi<TransferPaginationResponse>(() => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) params.append('search', search);
    if (storeId) params.append('storeId', storeId);
    if (type) params.append('type', type);
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    
    return apiClient.get<ApiResponse<TransferPaginationResponse>>(`/transfers?${params.toString()}`);
  });

export const fetchOneTransferAPI = (uuid: string) =>
  safeApi<TransferDTO>(() =>
    apiClient.get<ApiResponse<TransferDTO>>(`/transfers/${uuid}`)
  );

export const searchProductByCodeAPI = (code: string) =>
  safeApi<any>(() =>
    apiClient.get<ApiResponse<any>>(`/billing/products/search-by-code?code=${code}`)
  );

export const getStoresByItemCodeAPI = (itemCode: string) =>
  safeApi<any[]>(() =>
    apiClient.get<ApiResponse<any[]>>(`/inventory/items/stores-by-code/${itemCode}`)
  );
